import genActions from '../core/actions';
import types from './types';

const actions = genActions(types);

export default actions;
